import moment from 'moment';


function getNavigationDate(days, view, lang = 'se') {
    if (!days?.length) return null;

    if (view === 'day' && days?.[0]?.dateString) {
        let dateString = days?.[0]?.dateString;
        const [month, day, year] = dateString.split('/').map(Number);
        const date = new Date(year, month - 1, day);
        const dayOfWeek = date.getDay();
        const dayOfWeekString = [
            'Sunday'.translate(lang),
            'Monday'.translate(lang),
            'Tuesday'.translate(lang),
            'Wednesday'.translate(lang),
            'Thursday'.translate(lang),
            'Friday'.translate(lang),
            'Saturday'.translate(lang)
        ];

        const monthString = [
            'Jan'.translate(lang),
            'Feb'.translate(lang),
            'Mar'.translate(lang),
            'Apr'.translate(lang),
            'May'.translate(lang),
            'Jun'.translate(lang),
            'Jul'.translate(lang),
            'Aug'.translate(lang),
            'Sep'.translate(lang),
            'Oct'.translate(lang),
            'Nov'.translate(lang),
            'Dec'.translate(lang)
        ];
        return `${dayOfWeekString[dayOfWeek]} ${monthString?.[month - 1]} ${String(date.getDate()).padStart(2, '0')}`
    } else if ((view === 'week' || view === 'work-week') && days?.length) {
        let startDate = days?.[0]?.dateString;
        let endDate = days?.[days.length - 1]?.dateString;
        const [startMonth, startDay, startYear] = startDate.split('/').map(Number);
        const [endMonth, endDay, endYear] = endDate.split('/').map(Number);
        const _startDay = new Date(startYear, startMonth - 1, startDay);
        const _endDay = new Date(endYear, endMonth - 1, endDay);

        const shortMonthString = [
            'Jan'.translate(lang),
            'Feb'.translate(lang),
            'Mar'.translate(lang),
            'Apr'.translate(lang),
            'May'.translate(lang),
            'Jun'.translate(lang),
            'Jul'.translate(lang),
            'Aug'.translate(lang),
            'Sep'.translate(lang),
            'Oct'.translate(lang),
            'Nov'.translate(lang),
            'Dec'.translate(lang)
        ];
        const monthString = [
            'January'.translate(lang),
            'February'.translate(lang),
            'March'.translate(lang),
            'April'.translate(lang),
            'May'.translate(lang),
            'June'.translate(lang),
            'July'.translate(lang),
            'August'.translate(lang),
            'September'.translate(lang),
            'October'.translate(lang),
            'November'.translate(lang),
            'December'.translate(lang)
        ];
        const startMonthString = startMonth === endMonth ? monthString?.[startMonth - 1] : shortMonthString?.[startMonth - 1];
        const endMonthString = startMonth === endMonth ? monthString?.[endMonth - 1] : shortMonthString?.[endMonth - 1];

        if (startMonth === endMonth) {
            return `${startMonthString} ${String(_startDay.getDate()).padStart(2, '0')} – ${String(_endDay.getDate()).padStart(2, '0')}`;
        } else {
            return `${startMonthString} ${String(_startDay.getDate()).padStart(2, '0')} – ${endMonthString} ${String(_endDay.getDate()).padStart(2, '0')}`;
        }
    }
}
function getWeekDates(dateString) {
    if (!dateString) return null;
    const [month, day, year] = dateString.split('/').map(Number);
    const date = new Date(year, month - 1, day);

    let dayOfWeek = date.getDay();

    const monday = new Date(date);
    const diff = (dayOfWeek === 0 ? -6 : 1 - dayOfWeek);
    monday.setDate(date.getDate() + diff);

    const weekDates = Array.from({ length: 7 }, (_, i) => {
        const currentDate = new Date(monday);
        currentDate.setDate(monday.getDate() + i);

        return (
            String(currentDate.getMonth() + 1).padStart(2, '0') + '/' +
            String(currentDate.getDate()).padStart(2, '0') + '/' +
            currentDate.getFullYear()
        );
    });

    return weekDates;
}
function getWorkWeekDates(dateString) {
    if (!dateString) return null;
    const [month, day, year] = dateString.split('/').map(Number);
    const date = new Date(year, month - 1, day);

    let dayOfWeek = date.getDay();

    const monday = new Date(date);
    const diff = (dayOfWeek === 0 ? -6 : 1 - dayOfWeek);
    monday.setDate(date.getDate() + diff);

    const weekDates = Array.from({ length: 5 }, (_, i) => {
        const currentDate = new Date(monday);
        currentDate.setDate(monday.getDate() + i);

        return (
            String(currentDate.getMonth() + 1).padStart(2, '0') + '/' +
            String(currentDate.getDate()).padStart(2, '0') + '/' +
            currentDate.getFullYear()
        );
    });

    return weekDates;
}
function generateDays(date, view, getStringDateTs) {
    if (!date || !view) return [];
    let days = [];

    if (view === 'day') {
        days.push({
            dateString: date,
            isToday: date === getStringDateTs?.(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')
        });

    } else if (view === 'week') {
        let weekDays = getWeekDates(date);
        if (!weekDays || weekDays?.length !== 7) return [];
        for (let i = 0; i < weekDays.length; i++) {
            days.push({
                dateString: weekDays[i],
                isToday: weekDays[i] === getStringDateTs?.(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')
            });
        }
    } else if (view === 'work-week') {
        let weekDays = getWorkWeekDates(date);
        if (!weekDays || weekDays?.length !== 5) return [];
        for (let i = 0; i < weekDays.length; i++) {
            days.push({
                dateString: weekDays[i],
                isToday: weekDays[i] === getStringDateTs?.(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')
            });
        }
    }
    return days;
}
export const generateDateString = (date, view, lang = 'se', getStringDateTs) => {
    if (!date || !view) return date;

    if (view === 'month') {
        let month = moment(date).format('MMMM');
        let year = moment(date).format('YYYY');
        if (month && year) {
            return `${month?.translate(lang)} ${year}`;
        }
    } else if (view === 'week' || view === 'work-week') {
        let days = generateDays(date, view, getStringDateTs);
        let navigationDate = getNavigationDate(days, view, lang);
        if (navigationDate) {
            return navigationDate;
        }
    } else if (view === 'day') {
        let day = moment(date).format('DD');
        let month = moment(date).format('MMMM');
        let year = moment(date).format('YYYY');
        if (day && month && year) {
            return `${day} ${month?.translate(lang)} ${year}`;
        }
    }


    return date;
}

export const generateSections = (itemsArr) => {
    let sections = {};
    let items = [{ type: 0 }, ...itemsArr];
    let lastSectionId = -1;
    for (let i = 0; i < items.length; i++) {
        if (items[i].type == 0) {
            lastSectionId++;
            sections[lastSectionId] = {
                name: items[i].name,
                displayOnReferral: false,
                questions: [],
                conditions: items[i].conditions ? items[i].conditions : [],
                displayOnReferral: items[i].displayOnReferral,
                fontStyle: items[i].fontStyle,
                fontSize: items[i].fontSize,
                fontWeight: items[i].fontWeight,

            }
        }
        if (lastSectionId != -1 && items[i].type != 0) {


            let wikiLinks = [];

            items[i].wikiLinks = wikiLinks;


            if (items[i].type == 1) {
                let displayOnReferral = false;
                if (items[i].answers) {
                    for (let j = 0; j < items[i].answers.length; j++) {
                        if (items[i].answers[j].text) {
                            displayOnReferral = true;
                        }
                    }
                }

                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    answers: items[i].answers,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    displayOnReferral: displayOnReferral,
                    wikiLinks: items[i].wikiLinks,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                });

            } else if (items[i].type == 2) {
                let displayOnReferral = false;
                if (items[i].answers) {
                    for (let j = 0; j < items[i].answers.length; j++) {

                        if (items[i].answers[j].text) {
                            displayOnReferral = true;
                        }
                    }
                }
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    answers: items[i].answers,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    answerPrefix: items[i].answerPrefix,
                    userInput: items[i].userInput,
                    displayOnReferral: displayOnReferral || items[i].answerPrefix ? true : false,
                    wikiLinks: items[i].wikiLinks,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,

                })
            } else if (items[i].type == 3) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    answerPrefix: items[i].answerPrefix,
                    wikiLinks: items[i].wikiLinks,
                    displayOnReferral: true,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                })

            } else if (items[i].type == 4) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    text: items[i].text,
                    userInput: items[i].userInput,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    wikiLinks: items[i].wikiLinks,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                })
            } else if (items[i].type == 15) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    text: items[i].text,
                    userInput: items[i].userInput,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    wikiLinks: items[i].wikiLinks,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                })

            } else if (items[i].type == 5) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    wikiLinks: items[i].wikiLinks,
                    displayOnReferral: true,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                    score: items[i].score
                })

            } else if (items[i].type == 6) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    wikiLinks: items[i].wikiLinks,
                    displayOnReferral: true,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                    score: items[i].score
                })

            } else if (items[i].type == 7) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    wikiLinks: items[i].wikiLinks,
                    displayOnReferral: true,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                })

            } else if (items[i].type == 8) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    wikiLinks: items[i].wikiLinks,
                    displayOnReferral: true,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                })

            } else if (items[i].type == 9) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    wikiLinks: items[i].wikiLinks,
                    displayOnReferral: true,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                })

            } else if (items[i].type == 10) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    userInput: items[i].userInput,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    wikiLinks: items[i].wikiLinks,
                    displayOnReferral: true,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                })
            } else if (items[i].type == 12) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    wikiLinks: items[i].wikiLinks,
                    displayOnReferral: true,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                    score: items[i].score
                })
            } else if (items[i].type == 14) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    wikiLinks: items[i].wikiLinks,
                    displayOnReferral: true,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                    score: items[i].score
                })

            } else if (items[i].type == 13) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    wikiLinks: items[i].wikiLinks,
                    displayOnReferral: true,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                    score: items[i].score
                })

            } else if (items[i].type == 16) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    wikiLinks: items[i].wikiLinks,
                    displayOnReferral: true,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                    blocks: items[i].blocks,
                })

            } else if (items[i].type == 17) {
                sections[lastSectionId].questions.push({
                    id: items[i].id,
                    type: items[i].type,
                    name: items[i].name,
                    conditions: items[i].conditions ? items[i].conditions : [],
                    wikiLinks: items[i].wikiLinks,
                    displayOnReferral: true,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,
                    blocks: items[i].blocks,

                })

            }
        }
    }

    return Object.values(sections);
}

export const addMinutesToTime = (timeStr, minutesToAdd) => {
    if (!timeStr || !minutesToAdd) return timeStr;
    const [hours, minutes] = timeStr.split(':').map(Number);
    let totalMinutes = hours * 60 + minutes + minutesToAdd;

    totalMinutes = ((totalMinutes % 1440) + 1440) % 1440;

    const newHours = Math.floor(totalMinutes / 60);
    const newMinutes = totalMinutes % 60;

    return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
}

export const generateDistinctColors = (count) => {
    const goldenRatioConjugate = 0.618033988749895;
    let h = Math.random();
    const colors = [];

    for (let i = 0; i < count; i++) {
        h += goldenRatioConjugate;
        h %= 1;
        colors.push(hsvToHex(h, 0.5, 0.95));
    }
    return colors;
}

const hsvToHex = (h, s, v) => {
    let r, g, b;

    let i = Math.floor(h * 6);
    let f = h * 6 - i;
    let p = v * (1 - s);
    let q = v * (1 - f * s);
    let t = v * (1 - (1 - f) * s);

    switch (i % 6) {
        case 0: r = v; g = t; b = p; break;
        case 1: r = q; g = v; b = p; break;
        case 2: r = p; g = v; b = t; break;
        case 3: r = p; g = q; b = v; break;
        case 4: r = t; g = p; b = v; break;
        case 5: r = v; g = p; b = q; break;
    }

    return "#" + [r, g, b]
        .map(x => {
            const hex = Math.round(x * 255).toString(16);
            return hex.length === 1 ? "0" + hex : hex;
        })
        .join("");
}
export const getHumanReadable = (status, lang = 'se') => {
    if (!status) return status;
    let humanReadableStatus = humanReadable?.[status];
    if (humanReadableStatus) {
        return humanReadableStatus?.translate(lang);
    } else {
        return status;
    }
}

const humanReadable = {
    'reserved': 'Time Slot Reserved',
    'waiting-for-payment-before-submission': 'Waiting for payment',
    'waiting-for-approval': 'Waiting for approval',
    'waiting': 'Waiting',
    'waiting-for-payment': 'Waiting for payment',
    'disallowed': 'Disallowed',
    'in-progress': 'In progress',
    'allowed': 'Allowed',
    'return-for-update': 'Return for update',
    'patient-requested-another-time': 'Patient requested anoother time',
    'patient-rejected': 'Cancelled by patient', // 'Rejected by patient',
    'patient-accepted': 'Patient accepted',
    'clinic-accepted-requested-time': 'Clinic accepted requested time',
    'clinic-rejected-requested-time': 'Clinic rejected requested time',
    'approved-by-region-manager': 'Approved by region manager',
    'rejected-by-region-manager': 'Rejected by region manager',
    'scheduled': 'Scheduled',
    'visit-rescheduled': 'Visit rescheduled',
    'revisit-scheduled': 'Revisit scheduled',
    'not-booked': 'Cancelled by clinician', //'Not booked',
    'closed': 'Closed',
    'canceled-by-clinic': 'Cancelled by clinician', // 'Canceled by clinic'
    'requested-new-appointment': 'Requested new appointment',
    'external': 'External transfer',
    'not-scheduled': 'Not scheduled',
}

export const convertSvDateToEn = (dateString) => {
    if (!dateString) return '';

    const [year, month, day] = dateString.split('-').map(Number);
    if (!year || !month || !day) return '';

    return `${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}/${year}`;

}

export const splitDate = (str) => {
    if (!str || typeof str !== 'string') return null;
    const match = str.match(/^(\d{4}[-/.]\d{2}[-/.]\d{2}|\d{2}[-/.]\d{2}[-/.]\d{4})\s*(.*)$/);

    if (!match) {
        return { date: null, others: str };
    }

    const date = match[1].trim();
    const others = match[2].trim();

    return { date, others };
}

export const convertSplitDateToDivElements = (str, addNewLine = false) => {
    if (str) {
        let splitVal = splitDate(str);
        if (splitVal?.date && splitVal?.others?.length > 5) {
            return <>
                <div style={{ whiteSpace: 'nowrap' }}>{splitVal.date}</div>
                <div style={{ whiteSpace: 'nowrap' }}>{splitVal.others}</div>
            </>
        } else {
            return <>
                {str}
                {addNewLine && <br />}
            </>
        }

    }
    return str;
}


// module.exports = {
//     generateDateString,
//     generateSections,
// }